import React from 'react';
import { FiCheck, FiTrash2 } from 'react-icons/fi';

const PedagogyFieldHeader = ({ deleteMode, onToggleDeleteMode, labelClassName = '' }) => (
  <div className="mb-1.5 flex items-center justify-between gap-2">
    <h6
      className={`text-[8px] font-black text-[#1e293b] uppercase tracking-widest mb-0 ${labelClassName}`}
    >
      PEDAGOGY
    </h6>
    <button
      type="button"
      onClick={onToggleDeleteMode}
      title={deleteMode ? 'Finish deleting' : 'Delete pedagogies'}
      className={`shrink-0 w-7 h-7 rounded-lg flex items-center justify-center border transition-all ${
        deleteMode
          ? 'bg-red-600 border-red-600 text-white shadow-sm'
          : 'bg-white border-slate-200 text-slate-400 hover:border-red-200 hover:text-red-600 hover:bg-red-50'
      }`}
      aria-label={deleteMode ? 'Done deleting pedagogies' : 'Delete pedagogies'}
    >
      {deleteMode ? <FiCheck className="text-[13px]" /> : <FiTrash2 className="text-[12px]" />}
    </button>
  </div>
);

export default PedagogyFieldHeader;
